import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Topic } from '../../../topic-player/interfaces/topic.interface';
import { unitPlayerLazyLoadedState } from '../../../topic-player/routing/route-locales/unit-player-routes';
import { TopicLandingCms } from "../../interfaces/topic-landing-cms.interface";
import { TopicService } from '../../../topic-player/services/topic.service';
import { TranslateService } from '@nx/mono-common';
import { environment } from 'apps/learn-my-way/src/environments/environment';

@Component({
  selector: 'lmw-base-topic-landing',
  templateUrl: './topic-landing.component.html'
})
export class TopicLandingComponent implements OnInit {

  public topic: Topic;
  public subjectName: string;
  public subjectSlug: string;
  public topicLandingCms: TopicLandingCms;
  public subjectImageNumber: string;
  public requiresSignIn: boolean;
  public userSignedIn: boolean;
  public topicCompletedDate: string;

  private defaultImageNumber = '7';
  private localeId: string;
  private matchingCompletedTopicSlugs = [];

  constructor(private topicService: TopicService, private router: Router, private route: ActivatedRoute, private translateService: TranslateService) { }

  ngOnInit(): void {
    this.localeId = this.route.snapshot.data.localeId;
    this.topicLandingCms = this.route.snapshot.data.cmsData;
    this.requiresSignIn = this.route.snapshot.data.topic.requiresSignIn;
    this.userSignedIn = this.route.snapshot.data.userSignedIn;
    this.getTopicData(this.route.snapshot.data.topic);
    this.getImageNumber(this.route.snapshot.data.subjectImageNumber);
    this.getSubjectName();
    this.getAllTopicAttempts();
  }

  public startLearningClicked() {
    this.router.navigate([`/${unitPlayerLazyLoadedState.path}`], { queryParams: { subjectSlug: this.subjectSlug, topicSlug: this.topic.sk, locale: this.localeId } });
  }
  public translate(template: string) {
    return this.translateService.translate(template, environment.language);
  }

  private getSubjectName() {
    this.subjectSlug = this.route.snapshot.params['subject-slug'];
    this.subjectName = this.getSubjectNameFromSlug(this.subjectSlug);
  }

  private getAllTopicAttempts() {
    this.topicService
      .getTopicsAttemptsByCompleted(true)
      .subscribe((topicsFound) => {
        this.findCurrentTopicSlugInTopicsFound(topicsFound);
      });
  }

  private findCurrentTopicSlugInTopicsFound(topicsFoundArray) {
    topicsFoundArray.forEach(topic => {
      if (topic.SK.split(':')[1] === this.topic.sk) {
        this.matchingCompletedTopicSlugs.push(topic);
      }
    });
    this.setTopicCompletedString();
  }

  private setTopicCompletedString() {
    if (this.matchingCompletedTopicSlugs.length > 0) {
      this.topicCompletedDate = this.formatDateForLocale(this.matchingCompletedTopicSlugs[0].dateCreated);
    } else {
      this.topicCompletedDate = '';
    }
  }

  private formatDateForLocale(topicCompletedDate): string {
    return new Date(topicCompletedDate)
      .toLocaleString(this.localeId)
      .split(',')[0];
  }

  private getTopicData(resolvedTopicData) {
    if (resolvedTopicData) {
      this.topic = resolvedTopicData;
    }
  }

  private getImageNumber(resolvedImageNumber) {
    if (resolvedImageNumber) {
      this.subjectImageNumber = resolvedImageNumber;
    } else {
      this.subjectImageNumber = this.defaultImageNumber;
    }
  }

  private getSubjectNameFromSlug(slug) {
    const nameWithoutDashes = slug.replace(/\-/g, ' ');
    return nameWithoutDashes[0].toUpperCase() + nameWithoutDashes.slice(1);
  }
}
